<div class="custom-input-placeholder custom-dropdown" (click)="toggleDropdown($event)">
  <!-- Input displaying the selected date -->
  <div class="row nowrap align-center" style="gap: 0;">
    <input type="text"
           [value]="getFormattedDate()"
           readonly
           placeholder="Select a date"
           class="input-control"
           style="cursor: default; border-right: none; "/>
    <svg class="select-icon" [ngClass]="{ 'select-focus-icon': dropdownOpen }" width="35" height="34" viewBox="0 0 32 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="35" height="35" stroke="transparent" stroke-opacity="0.2" />
      <path d="M10 14L16 20L22 14" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
  <!-- Calendar dropdown -->
  <div *ngIf="dropdownOpen" class="calendar-dropdown">
    <!-- Month and year navigation -->
    <div class="calendar-header">
      <button (click)="changeMonth(-1, $event)" style=" background: none !important;">
        <svg style="transform: rotateZ(90deg); background: none !important;" [ngClass]="{ 'select-focus-icon': dropdownOpen }" width="32" height="34" viewBox="0 0 32 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="31" height="33" stroke="none" stroke-opacity="0.2" />
          <path d="M10 14L16 20L22 14" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <p style=" height: 20px;">{{ months[currentMonth] }} {{ currentYear }}</p>
      <button (click)="changeMonth(1, $event)" style=" background: none !important;">
        <svg style="transform: rotateZ(270deg); background: none !important;" [ngClass]="{ 'select-focus-icon': dropdownOpen }" width="32" height="34" viewBox="0 0 32 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="31" height="33" stroke="none" stroke-opacity="0.2" />
          <path d="M10 14L16 20L22 14" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Days of the current month -->
    <div class="calendar-days">
      <button *ngFor="let day of days" (click)="selectDate(day, $event)">{{ day }}</button>
    </div>
  </div>
</div>
